module.exports = __webpack_public_path__ + "img/home.cbf2327b.png";